/**
 * Handle the fail accordion in the full site scan.
 */

import { __ } from '@wordpress/i18n';

/**
 * Fill the #fail-accordion with the data from postsThatFailedScan
 *
 * @param {Object[]} postsThatFailedScan
 */
export const fillFailsAccordion = ( postsThatFailedScan = [] ) => {
	// We can't do anything if there are no posts.
	if ( ! postsThatFailedScan.length ) {
		return;
	}

	const failAccordion = document.getElementById( 'fail-accordion' );
	const tbody = failAccordion?.querySelector( 'table > tbody' );
	const template = tbody?.querySelector( 'tr' );
	// We can't do anything if there is no table/body or a row to act as template.
	if ( ! template ) {
		return;
	}

	// Remove all rows from the table to start fresh.
	tbody.innerHTML = '';

	postsThatFailedScan.forEach( ( row ) => {
		// We need the row to have all 3 of these to create a row. post_edit_url, post_title, post_type
		if ( ! row.post_edit_url || ! row.post_title || ! row.post_type ) {
			return;
		}

		const clone = template.cloneNode( true );

		const link = document.createElement( 'a' );
		link.href = row.post_edit_url.replace( '&amp;', '&' );
		link.textContent = row.post_title;

		const titleCell = clone.querySelector( 'td' );
		titleCell.innerHTML = '';
		titleCell.appendChild( link );

		const typeCell = clone.querySelector( 'td:nth-child(2)' );
		typeCell.innerHTML = '';
		typeCell.textContent = __( row.post_type, 'accessibility-checker-pro' );

		tbody.appendChild( clone );
	} );

	// Show the fail accordion if there are any rows.
	if ( tbody.children.length ) {
		failAccordion.style.display = 'block';
	}

	// set the data-rendered-from-php attribute to false since it is now rendered from JS.
	failAccordion.setAttribute( 'data-rendered-from-php', 'false' );

	// Add a heading/message if not already present
	let heading = failAccordion.querySelector( '.edacp-fail-accordion-heading' );
	if ( ! heading ) {
		heading = document.createElement( 'div' );
		heading.className = 'edacp-fail-accordion-heading';
		heading.textContent = __( 'The following pages could not be scanned:', 'accessibility-checker-pro' );
		failAccordion.insertBefore( heading, failAccordion.firstChild );
	}
};
